import {getField, updateField} from 'vuex-map-fields';
import GroupModule from '@/commonFunction/consumerModule'

let current_module = new GroupModule('/ws/users/group/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'ID', value: 'id', sortable: true, filterable: true, divider: true,},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: 260,
        sortBy: ['name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        GroupTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}